// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ae565ca3","29":"79ac41ec","179":"847f49ea","293":"2b9485c2","307":"411034f4","468":"9d407800","515":"549b8c06","555":"255e24c2","612":"0522d4f0","717":"a7067717","852":"01de5aa5","867":"bcb7be20","974":"883bbce5"}[chunkId] + ".chunk.js";
};